// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiInitialCoverageLimit {
    static getAttributeTypeMap() {
        return PharmacyBiInitialCoverageLimit.attributeTypeMap;
    }
}
PharmacyBiInitialCoverageLimit.discriminator = undefined;
PharmacyBiInitialCoverageLimit.additionalProperties = false;
PharmacyBiInitialCoverageLimit.attributeTypeMap = [
    {
        "name": "metAmount",
        "baseName": "metAmount",
        "type": "string"
    },
    {
        "name": "total",
        "baseName": "total",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiInitialCoverageLimit.js.map